<template>
  <ellipsis-button
    placement="right"
    heading="Schedule settings"
    :show-options="['slot', 'delete']"
    @delete="onDelete()"
    ref="popover">
    <div>
      <!--
      <div class="clearfix">
        <h2 class="m-0 text-header" :style="{ display: 'inline', color: timeslot_collection.color }">
          {{timeslot_collection.name}}
        </h2>
      </div>
      -->

      <!-- <el-button size="mini" type="danger" @click="onDelete">Delete Timeslot Collection</el-button> -->
      <!-- <el-button style="float: right" size="mini" type="info" @click="$refs.popover.hide()">Cancel</el-button> -->
    </div>

  </ellipsis-button>
</template>

<script>
import { COLOR_LIST as predefineColors } from '@/misc/colors'
import ConfirmDeletePromptMixin from "@/components/Mixins/Prompts/ConfirmDeletePrompt"

export default {
  mixins: [ ConfirmDeletePromptMixin ],
  props: {
    timeslot_collection_id: { required: true },
    timeslot_collection: {
      type: Object,
      default: () => {return null}
    },
  },
  data: () => ({
    predefineColors: predefineColors,
  }),
  computed: {
  },
  methods: {
    onDelete() {
      this.$confirm_delete_prompt('schedule' ).then(({ notify }) => {
        this.$emit('deleted', this.timeslot_collection_id);

        this.$api.timeslot_collection_delete({
          timeslotCollectionId: this.timeslot_collection_id,
          delete_mode: 'hard'
        }).then(notify)
      }).catch(e => e)
    },

    onSetCollectionName( newName ) {
      console.log("Updating collection title to ", this.timeslot_collection_id, newName);
      this.$api.timeslot_collection_set_name({
        timeslotCollectionId: this.timeslot_collection_id,
        name: newName
      });
    },

    onSetColor(color) {
      console.log("onSetColor", color)
      this.$api.timeslot_collection_set_color({
        timeslotCollectionId: this.timeslot_collection_id,
        color: color
      })
    },
  },
  components: {
  }
}
</script>
